/** Competitor fundraiser screenshots — on only in environments whose build sets the flag. */
export const screenshotsEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_FUNDRAISER_SCREENSHOTS === 'true';
